import Card from '@bexs/dollar/components/Card';
import { TypographyProps } from '@bexs/dollar/components/Typography/types';
import styled from 'styled-components';

interface ChartLabelProps {
  labelColor: string;
  isActive: boolean;
}

export const ChartWrapper = styled.div`
  position: relative;
  width: 250px;
  height: 250px;
  margin-right: 3%;
  svg {
    path {
      transition: 0.3s all;
    }
  }
`;

export const ChartLabelWrapper = styled.div``;

export const ChartLabel = styled.div<ChartLabelProps>`
  position: relative;
  padding-left: 26px;
  cursor: pointer;
  transition: all 0.2s;
  &:not(:first-of-type) {
    margin-top: 24px;
  }

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 18px;
    height: 18px;
    border-radius: 100%;
    border: 2px solid
      ${({ labelColor, isActive, theme }) =>
        isActive ? labelColor : theme.colors.mediumGrey};
  }

  p {
    font-size: 0.875rem;
    color: ${({ isActive, theme }) =>
      isActive ? theme.colors.darkGrey : theme.colors.mediumGrey};
    margin: 0;
  }

  span {
    display: block;
    color: ${({ labelColor, isActive, theme }) =>
      isActive ? labelColor : theme.colors.mediumGrey};
    font-size: 1.125rem;
    margin-top: 4px;
  }
`;

export const SummaryCard = styled(Card)`
  padding: 32px;
  h3 {
    font-size: 18px;
    font-weight: 400;
    text-transform: uppercase;
  }
`;

export const CurrencyIndicator = styled.div<TypographyProps>`
  margin: 8px;
  color: ${({ theme }) => theme.global.colors.basic.grey.variations[3]};
  text-transform: uppercase;
`;
